// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CarryOutFilledSvg from "@fishx/icons-svg/es/asn/CarryOutFilled";
import FishxIcon from '../components/FishxIcon';

var CarryOutFilled = function CarryOutFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CarryOutFilledSvg
  }));
};

CarryOutFilled.displayName = 'CarryOutFilled';
export default React.forwardRef(CarryOutFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CarryOutFilled.js
// module id = 2184
// module chunks = 0